import { render, staticRenderFns } from "./ScrollTableDetail.vue?vue&type=template&id=3327347f&scoped=true&"
import script from "./ScrollTableDetail.vue?vue&type=script&lang=js&"
export * from "./ScrollTableDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTableDetail.vue?vue&type=style&index=0&id=3327347f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327347f",
  null
  
)

export default component.exports